/* PavCon, LLC Proprietary.All rights reserved 2022 */

const INITIAL_STATE: MonitorReviewState = {
  navigationAction: {
    action: null,
    uuid: null,
    navigationAndSubmit: false,
  },
  reloadStats: false,
  currentPage: null,
  currentRecord: null,
  wucList: [],
};

export const NAMESPACE = 'MONITOR-REVIEW';

export const MonitorReviewActions = {
  INIT: `${NAMESPACE}.INIT`,
  SET_NAVIATION_ACTION: `${NAMESPACE}.SET_NAVIATION_ACTION`,
  ADD_WUCS: `${NAMESPACE}.ADD_WUCS`,
  CLEAR_WUC_LIST: `${NAMESPACE}.CLEAR_WUC_LIST`,
  SET_CURRENT_PAGE: `${NAMESPACE}.SET_CURRENT_PAGE`,
  SET_CURRENT_RECORD: `${NAMESPACE}.SET_CURRENT_RECORD`,
  RELOAD_USER: `${NAMESPACE}.RELOAD_USER`,
  KEEP_CURRENT_STATE: `${NAMESPACE}.KEEP_CURRENT_STATE`,
  RELOAD_STATS: `${NAMESPACE}.RELOAD_STATS`,
};

export const MonitorReviewReducer = (state: MonitorReviewState = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case MonitorReviewActions.INIT:
      state = INITIAL_STATE;
      return state;
    case MonitorReviewActions.SET_NAVIATION_ACTION:
      return {
        ...state,
        navigationAction: action.payload,
      };
    case MonitorReviewActions.SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.payload,
      };
    case MonitorReviewActions.ADD_WUCS:
      return {
        ...state,
        wucList: state.wucList.concat(action.payload),
      };
    case MonitorReviewActions.CLEAR_WUC_LIST:
      return {
        ...state,
        wucList: [],
      };
    case MonitorReviewActions.RELOAD_STATS:
      return {
        ...state,
        reloadStats: action.payload,
      };
    case MonitorReviewActions.SET_CURRENT_RECORD:
      return {
        ...state,
        currentRecord: action.payload,
      };
    default:
      return state;
  }
};

export interface MonitorReviewState {
  navigationAction: {
    action: number;
    uuid: string;
    navigationAndSubmit: boolean;
  };
  reloadStats: boolean;
  currentPage: number;
  currentRecord: any;
  wucList: any[];
}

/* PavCon, LLC Proprietary.All rights reserved 2022 */
